import React, { Component } from "react";
import TableTypeEnum from "../../../models/TableTypeEnum";
import OwButton from "../../shared/OwButton/OwButton";

type Props = {
    updateTableView: (tableType: TableTypeEnum) => void;
    hasPhotos: boolean;
    match: any;
};

type State = {
    standardTable: boolean;
    photosTable: boolean;
    smallTable: boolean;
    isOnline: boolean;
    isOfflineOrder: boolean;
};

class OwToggleOrderEntryTableView extends Component<Props, State> {
    static defaultProps = {
        hasPhotos: true,
    };

    readonly state: State = {
        standardTable: false,
        photosTable: true,
        smallTable: false,
        isOnline: navigator.onLine,
        isOfflineOrder: this.props.match.params.order_guid.indexOf("offline") >= 0,
    };

    componentDidMount(): void {
        window.addEventListener("online", this.setOnlineStatus);
        window.addEventListener("offline", this.setOnlineStatus);

        this.setState({
            photosTable: this.state.isOnline,
            standardTable: !this.state.isOnline,
        });
    }

    componentWillUnmount(): void {
        window.removeEventListener("online", this.setOnlineStatus);
        window.removeEventListener("offline", this.setOnlineStatus);
    }

    setOnlineStatus = () => {
        this.setState({
            isOnline: navigator.onLine,
        });
    };

    toggleSmallTable = () => {
        const state = this.state;

        state.standardTable = false;
        state.photosTable = false;
        state.smallTable = true;

        this.setState(state);

        this.props.updateTableView(TableTypeEnum.SMALL);
    };

    togglePhotosTable = () => {
        const state = this.state;

        state.standardTable = false;
        state.photosTable = true;
        state.smallTable = false;

        this.setState(state);

        this.props.updateTableView(TableTypeEnum.PHOTOS);
    };

    toggleStandardTable = () => {
        const state = this.state;

        state.standardTable = true;
        state.photosTable = false;
        state.smallTable = false;

        this.setState(state);

        this.props.updateTableView(TableTypeEnum.STANDARD);
    };

    render() {
        return (
            <div className="OwToggleOrderEntryTableView">
                <div className={"btn-group"}>
                    <OwButton
                        className={"btn-primary " + (this.state.smallTable ? "active" : "")}
                        hoverTitle={"Small Table"}
                        centerIconClass={"fad fa-list-alt"}
                        fn={() => {
                            this.toggleSmallTable();
                        }}
                    />
                    <OwButton
                        className={"btn-primary " + (this.state.standardTable ? "active" : "")}
                        hoverTitle={"Standard Table"}
                        centerIconClass={"fad fa-list"}
                        fn={() => {
                            this.toggleStandardTable();
                        }}
                    />
                    {this.state.isOnline ? (
                        <OwButton
                            className={"btn-primary " + (this.state.photosTable ? "active" : "")}
                            hoverTitle={"Photos Table"}
                            centerIconClass={"fad fa-image"}
                            fn={() => {
                                this.togglePhotosTable();
                            }}
                        />
                    ) : null}
                </div>
            </div>
        );
    }
}

export default OwToggleOrderEntryTableView;
